import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import client from './rest/AdminClient';
const _getBridgeReasonCodes = () => {
    const queryString = qs.stringify({
        default: true,
    });
    return client({
        method: 'GET',
        path: `/api/v2/shippers/reason-codes?${queryString}`,
    });
};
export const getBridgeReasonCodes = async () => {
    var _a, _b;
    const response = await _getBridgeReasonCodes();
    const items = ((_b = (_a = response === null || response === void 0 ? void 0 : response.entity) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.items) || [];
    return items;
};
export const useGetBridgeReasonCodes = (options = {}) => {
    return useQuery(Object.assign({ queryKey: ['bridgeReasonCodes'], queryFn: getBridgeReasonCodes, retry: 1 }, options));
};
const _createException = (payload) => {
    return client({
        method: 'POST',
        path: `/admin/api/market-exceptions/bulk`,
        entity: JSON.stringify(payload),
    });
};
export const createException = async (body) => {
    const response = await _createException(body);
    const items = (response === null || response === void 0 ? void 0 : response.entity) || {};
    return items;
};
const _getExceptions = (params) => {
    const queryString = qs.stringify(params);
    return client({
        method: 'GET',
        path: `/admin/api/market-exceptions/shipment?${queryString}`,
    });
};
export const getExceptions = async (params) => {
    var _a;
    const response = await _getExceptions(params);
    const items = ((_a = response === null || response === void 0 ? void 0 : response.entity) === null || _a === void 0 ? void 0 : _a.items) || [];
    return items;
};
export const useGetExceptions = (params, options = {}) => {
    return useQuery(Object.assign({ queryKey: ['exceptions', params === null || params === void 0 ? void 0 : params.shipment_id], queryFn: () => {
            return getExceptions(params);
        }, enabled: !!(params === null || params === void 0 ? void 0 : params.shipment_id) }, options));
};
export const _getBridgeCodeFilters = (params) => {
    const queryString = qs.stringify(params);
    return client({
        method: 'GET',
        path: `/admin/api/market-exceptions/filters?${queryString}`,
    });
};
export const getBridgeCodeFilters = async (filterType) => {
    var _a;
    const response = await _getBridgeCodeFilters({ filterType });
    const items = ((_a = response === null || response === void 0 ? void 0 : response.entity) === null || _a === void 0 ? void 0 : _a.filterOptions) || [];
    return items;
};
